import { Controller } from "@hotwired/stimulus"

// Affiche les pills de sous-catégorie uniquement pour la section (catégorie) active.
export default class extends Controller {
  static targets = ["group", "subCategoryWrapper"]

  static values = {
    activeSection: String,
  }

  activeSectionValueChanged() {
    this.sync()
  }

  connect() {
    this.sync()
  }

  sync() {
    const section = this.activeSectionValue
    const showSubFilters = section.length > 0

    if (this.hasSubCategoryWrapperTarget) {
      this.subCategoryWrapperTarget.classList.toggle("d-none", !showSubFilters)
    }

    this.groupTargets.forEach((group) => {
      const matches = group.dataset.section === section
      group.classList.toggle("d-none", !matches)
    })
  }
}
